var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',[_c('source',{attrs:{"media":"(min-width:768px)","srcset":_vm.url + '?x-oss-process=image/resize,w_450,limit_1/format,webp'}}),_c('img',{staticClass:"text-xs",class:_vm.imgClass,attrs:{"src":_vm.url + '?x-oss-process=image/resize,w_300,limit_1/format,webp',"alt":_vm.name},on:{"error":_vm.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }